// TOP LEVEL IMPORTS
import React from 'react';
import Papa from 'papaparse';
// ANTD
import Button from 'components/common/Button';

// CONSTANTS & DESTRUCTURING
// ===================================

const downloadFile = (data, exportFilename) => {
  let csvData = new Blob([data], { type: 'text/csv;charset=utf-8;' });
  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(csvData, exportFilename);
  } else {
    // In FF link must be added to DOM to be clicked
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(csvData);
    link.setAttribute('download', exportFilename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

export class DownloadCSV extends React.Component {
  state = {
    loading: false,
  };

  onDownload = () => {
    let data = Papa.unparse(this.props.dataSource, { header: true });
    console.log({
      data,
    });
    downloadFile(data, 'user-data.csv');
    this.setState({ loading: false });
  };

  onClick = () => {
    if (this.state.loading) {
      return null; // exit the function if you're already loading
    }
    this.setState({ loading: true });
    return this.onDownload();
  };

  render() {
    return (
      <Button
        loading={this.state.loading}
        disabled={this.state.loading}
        type="dashed"
        onClick={this.onClick}
        size="large"
        icon="download"
      >
        {!this.state.loading ? 'Download CSV' : 'Downloading'}
      </Button>
    );
  }
}

export default DownloadCSV;



// WEBPACK FOOTER //
// ./src/components/common/DownloadCSV/index.js